import $fn from '@/utils/fn';
import {
    getUserInfo,
    getMenu,
    DetailList,
    getByRefresh
} from '@/req/user';
export default {
    namespaced: true,
    state: {
        // 用户信息
        info: "",
        // 消息提示
        message: "",
        minHeight: "",
        // 菜单列表
        menu: [],
        // 用户资料
        formInline: {},
        token: "",
        platform: [],
        game: [],
        gametype: [],
        group: [],
        spacetype: [],
        gameengine: [],
        serverlist: []
    },
    // getters:{},
    mutations: {
        setInfo(state: { info: any; }, obj: any) {
            state.info = obj
        },
        setMenu(state: { menu: any; }, obj: any) {
            state.menu = obj
        },
        setPlatform(state: { platform: any; }, obj: any) {
            state.platform = obj
        },
        setGame(state: { game: any; }, obj: any) {
            state.game = obj
        },
        setGametype(state: { gametype: any; }, obj: any) {
            state.gametype = obj
        },
        setGroup(state: { group: any; }, obj: any) {
            state.group = obj
        },
        setSpacetype(state: { spacetype: any; }, obj: any) {
            state.spacetype = obj
        },
        setGameengine(state: { gameengine: any; }, obj: any) {
            state.gameengine = obj
        },
        setServerlist(state: { serverlist: any; }, obj: any) {
            state.serverlist = obj
        },
        setByRefresh(state: { formInline: any; }, obj: any) {
            state.formInline = obj;
        },
    },
    actions: {
        async getByRefresh({
            commit
        }) {
            const obj = {
                token: $fn.cookies.getToken(),
            };
            const res = await getByRefresh(obj);
            commit('setByRefresh', res.data.userinfo);
        },
        async authInfo({
            commit,
            // tslint:disable-next-line:align
        }, info) {
            commit('setInfo', info)
        },
        async updateMenu({
            commit,
        }) {
            const res = await getMenu()
            if ($fn.n(res.code) !== 200) {
                window.App.$Message.error(res.msg)
            } else {
                commit('setMenu', res.data)
            }

        },
        /*****************************下拉列表 *************************************************************/
        async getPlatform({
            commit,
        }) {
            const obj = {
                token: $fn.cookies.getToken(),
                type: "platform"
            }
            const res = await DetailList(obj)
            commit('setPlatform', res.data)
        },
        async getGame({
            commit,
        }) {
            const obj = {
                token: $fn.cookies.getToken(),
                type: "game"
            }
            const res = await DetailList(obj)
            commit('setGame', res.data)
        },
        async getGametype({
            commit,
        }) {
            const obj = {
                token: $fn.cookies.getToken(),
                type: "gametype"
            }
            const res = await DetailList(obj)
            commit('setGametype', res.data)
        },
        async getGroup({
            commit,
        }) {
            const obj = {
                token: $fn.cookies.getToken(),
                type: "group"
            }
            const res = await DetailList(obj)
            commit('setGroup', res.data)
        },
        async getSpacetype({
            commit,
        }) {
            const obj = {
                token: $fn.cookies.getToken(),
                type: "spacetype"
            }
            const res = await DetailList(obj)
            commit('setSpacetype', res.data)
        },
        async getServerlist({
            commit,
        }) {
            const obj = {
                token: $fn.cookies.getToken(),
                type: "serverlist"
            }
            const res = await DetailList(obj)
            commit('setServerlist', res.data)
        },
        // async initDetailList({ commit }) {
        //     this.getPlatform(commit);
        //     this.getGame(commit)
        //     this.getGametype(commit)
        //     this.getGroup(commit)
        //     this.getServerlist(commit)
        //     this.getSpacetype(commit)
        // },

        /*****************************************  ********************************/
        // 设置当前用户角色
        async updateInfo({
            commit,
        }) {
            try {
                // const res = await getUserInfo()
                // if ($fn.n(res.code) === 200) {
                //     commit('setInfo', res.data)
                // } else {
                //     if (window.location.href.indexOf('/login') === -1) {
                //         window.App.$router.push({
                //             path: '/login',
                //         })
                //     }
                // }
            } catch (err) {
                if (window.location.href.indexOf('/login') === -1) {
                    window.App.$router.push({
                        path: '/login',
                    })
                }
            }
        },
    },
}
